"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoContextCache = void 0;
const tslib_1 = require("tslib");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const distance_1 = tslib_1.__importDefault(require("@turf/distance"));
const helpers_1 = require("@turf/helpers");
const TurfUtils_1 = require("../TurfUtils");
const turf_1 = require("@turf/turf");
const TypeHelpers_1 = require("../../TypeHelpers");
const constructs_1 = require("../../../model/constructs");
const defaultUnits = 'meters';
class GeoContextCache {
    constructor({ owner, cache, units = defaultUnits, precision = 2 }) {
        /** use to maintain cache so that all items are within given range */
        this.flushGreaterThanDistance = (distance, units) => {
            const comaribleDistance = (0, helpers_1.convertLength)(distance, units, this.units);
            Object.entries(this.cache).forEach(([k, v]) => {
                if (v.distance > comaribleDistance) {
                    delete this.cache[k];
                }
            });
        };
        /** use to populate and to update item which its position changes */
        this.upsertItem = (item) => {
            if ((0, iotv_v3_types_1.isPosition)(this.owner.location) && (0, iotv_v3_types_1.isPosition)(item.location)) {
                this._addToCache(item.sk, item.location);
            }
        };
        /** internal */
        this._addToCache = (key, location) => {
            if ((0, iotv_v3_types_1.isPosition)(this.owner.location) && (0, iotv_v3_types_1.isPosition)(location)) {
                const from = (0, TurfUtils_1.gPointToTPosition)(this.owner.location);
                const to = (0, TurfUtils_1.gPointToTPosition)(location);
                const _distance = (0, TypeHelpers_1.roundDecimals)((0, distance_1.default)(from, to, { units: this.units }), this.precision);
                const _bearing = (0, TypeHelpers_1.roundDecimals)((0, turf_1.bearing)(from, to, { final: true }), this.precision);
                this.cache[key] = {
                    position: location,
                    distance: _distance,
                    bearingDeg: _bearing,
                    units: 'meters'
                };
            }
        };
        /** use to update cache when owner position changes */
        this.recalculate = () => {
            Object.entries(this.cache).forEach(([k, v]) => this._addToCache(k, v.position));
        };
        this.getItemCount = () => Object.keys(this.cache).length;
        this.cache = cache ?? {};
        this.owner = owner;
        this.units = units;
        this.precision = precision;
    }
}
exports.GeoContextCache = GeoContextCache;
tslib_1.__decorate([
    (0, constructs_1.enumerable)(false),
    tslib_1.__metadata("design:type", Object)
], GeoContextCache.prototype, "owner", void 0);
